import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLaptopLocalComputer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 17.5C9.58579 17.5 9.25 17.8358 9.25 18.25C9.25 18.6642 9.58579 19 10 19H14C14.4142 19 14.75 18.6642 14.75 18.25C14.75 17.8358 14.4142 17.5 14 17.5H10Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.25 4.75V14.5729L1.54033 17.9923C1.3494 18.3742 1.25 18.7952 1.25 19.2221V19.75C1.25 20.7165 2.0335 21.5 3 21.5H21C21.9665 21.5 22.75 20.7165 22.75 19.75V19.2221C22.75 18.7952 22.6506 18.3742 22.4597 17.9923L20.75 14.5729V4.75C20.75 3.7835 19.9665 3 19 3H5C4.0335 3 3.25 3.7835 3.25 4.75ZM5 4.5C4.86193 4.5 4.75 4.61193 4.75 4.75V14H19.25V4.75C19.25 4.61193 19.1381 4.5 19 4.5H5ZM2.88197 18.6631L4.46353 15.5H19.5365L21.118 18.6631C21.2048 18.8367 21.25 19.0281 21.25 19.2221V19.75C21.25 19.8881 21.1381 20 21 20H3C2.86193 20 2.75 19.8881 2.75 19.75V19.2221C2.75 19.0281 2.79518 18.8367 2.88197 18.6631Z",
		fill: "currentColor"
	})]
});
export { SvgIconLaptopLocalComputer as ReactComponent };
